import React from 'react';
import Card from './Card';

const Insights = () => {
    const blogs = [
        { category: 'AUTOMATION', icon: 'fa-robot', title: 'Why Hyper-Automation Is the Future of Operations' },
        { category: 'PROCESS', icon: 'fa-map', title: 'Process Mapping: Save Millions with a Simple Walkthrough' },
        { category: 'DEVELOPMENT', icon: 'fa-code-branch', title: 'No-Code vs Custom: Which to Choose for Your Automation?' },
        { category: 'STRATEGY', icon: 'fa-rocket', title: 'How to Prepare Your Organisation for Digital Transformation' }
    ];

    return (
        <section id="insights" style={{ padding: '80px 0', backgroundColor: '#f9fafb' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <span style={{ color: '#1746A2', fontWeight: 500 }}>Knowledge Hub</span>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: '#0C1A36',
                        marginTop: '8px',
                        marginBottom: '16px'
                    }}>
                        Insights & Blog
                    </h2>
                    <p style={{ color: '#4b5563', maxWidth: '600px', margin: '0 auto' }}>
                        Stay updated with the latest in digital transformation
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '16px auto 0'
                    }}></div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                    gap: '24px'
                }}>
                    {blogs.map((blog, index) => (
                        <Card
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
                                border: '1px solid #f3f4f6'
                            }}
                        >
                            <div style={{
                                height: '160px',
                                background: index % 2 === 0
                                    ? 'linear-gradient(135deg, #1746A2, #0C1A36)'
                                    : 'linear-gradient(135deg, #0C1A36, #1746A2)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <i className={`fas ${blog.icon}`} style={{
                                    fontSize: '64px',
                                    color: 'rgba(255, 255, 255, 0.3)'
                                }}></i>
                            </div>

                            <div style={{ padding: '24px' }}>
                                <span style={{
                                    fontSize: '12px',
                                    color: '#1746A2',
                                    fontWeight: 500
                                }}>
                                    {blog.category}
                                </span>
                                <h3 style={{
                                    fontWeight: 'bold',
                                    color: '#0C1A36',
                                    marginTop: '8px',
                                    marginBottom: '12px',
                                    fontSize: '16px',
                                    lineHeight: 1.4
                                }}>
                                    {blog.title}
                                </h3>
                                <a
                                    href="#"
                                    style={{
                                        color: '#1746A2',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        textDecoration: 'none',
                                        transition: 'gap 0.3s'
                                    }}
                                >
                                    Read More <i className="fas fa-arrow-right"></i>
                                </a>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Insights;